<template>
  <li v-if="item.has_feedbacks">
    <!-- Section Header -->
    <div class="ad-section-header">
      <h4>
        {{ $t('general.experience_sharing') }}
        <span class="ad-feedback-count">({{ item.approved_comments.length }} {{ $t("education.Sharing") }})</span>
      </h4>
    </div>

    <!-- Comments List -->
    <div class="ad-feedback-list">
      <div v-for="(comment, index) in item.approved_comments" :key="'comment_index_' + index"
           :id="'comment_' + comment.id" class="ad-feedback-item">
        <div class="ad-feedback-avatar">
          <img :src="comment.user.photo_link" alt="" />
        </div>
        <div class="ad-feedback-content">
          <div class="ad-feedback-header">
            <span class="ad-feedback-name">{{ comment.user.name }} {{ comment.user.surname }}</span>
            <span v-if="comment.user.position?.name" class="ad-feedback-position">{{ comment.user.position.name }}</span>
          </div>
          <p class="ad-feedback-text">
            {{ comment.text }}
            <span v-if="comment.status_id === 1" class="ad-feedback-pending">
              ({{ $t('general.sent_to_admin_approval') }})
            </span>
          </p>
        </div>
      </div>
    </div>

    <!-- New Comment -->
    <div class="ad-feedback-form">
      <div class="ad-feedback-avatar">
        <img :src="userPhoto" alt="" />
      </div>
      <div class="ad-feedback-input-wrapper">
        <textarea :value="commentText" :placeholder="$t('general.write_your_experiences_here')"
                  class="ad-feedback-textarea" rows="4"
                  @input="$emit('update:commentText', $event.target.value)"></textarea>
        <div class="ad-feedback-actions">
          <button class="ad-btn ad-btn--primary ad-btn--sm" type="button" @click="$emit('submit')">
            <i class="uil-message"></i>
            {{ $t("messages.send") }}
          </button>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: "AssignmentFeedbacks",
  props: {
    item: { type: Object, required: true },
    userPhoto: { type: String, default: '' },
    commentText: { type: String, default: '' },
  },
  emits: ['update:commentText', 'submit'],
};
</script>

<style scoped>
/* Feedback Count */
.ad-feedback-count {
  font-size: 14px;
  font-weight: 400;
  color: #64748b;
  margin-left: 4px;
}

/* Feedback List */
.ad-feedback-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.ad-feedback-item {
  display: flex;
  gap: 14px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.ad-feedback-avatar {
  flex-shrink: 0;
}

.ad-feedback-avatar img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e2e8f0;
}

.ad-feedback-content {
  flex: 1;
  min-width: 0;
}

.ad-feedback-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  flex-wrap: wrap;
}

.ad-feedback-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.ad-feedback-position {
  font-size: 12px;
  color: #64748b;
  background: #e2e8f0;
  padding: 2px 8px;
  border-radius: 4px;
}

.ad-feedback-text {
  font-size: 14px;
  color: #475569;
  line-height: 1.6;
  margin: 0;
  word-break: break-word;
}

.ad-feedback-pending {
  font-weight: 600;
  color: #d97706;
  font-size: 13px;
}

/* New Comment Form */
.ad-feedback-form {
  display: flex;
  gap: 14px;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.ad-feedback-input-wrapper {
  flex: 1;
  min-width: 0;
  width: 100%;
}

.ad-feedback-textarea {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  background: #f8fafc;
  resize: vertical;
  transition: border-color 0.2s, box-shadow 0.2s;
  font-family: inherit;
  line-height: 1.5;
}

.ad-feedback-textarea:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  background: #fff;
}

.ad-feedback-textarea::placeholder {
  color: #94a3b8;
}

.ad-feedback-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

/* Responsive */
@media (max-width: 768px) {
  .ad-feedback-item {
    padding: 12px;
    gap: 10px;
  }

  .ad-feedback-avatar img {
    width: 36px;
    height: 36px;
  }

  .ad-feedback-form {
    padding: 14px;
    gap: 10px;
  }

  .ad-feedback-textarea {
    padding: 10px 12px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .ad-feedback-form {
    flex-direction: column;
    align-items: flex-start;
  }

  .ad-feedback-avatar img {
    width: 32px;
    height: 32px;
  }

  .ad-feedback-actions {
    width: 100%;
  }

  .ad-feedback-actions .ad-btn {
    width: 100%;
  }
}
</style>
